import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import { INTEGRATION_ICONS_MAP } from '../data/integrationIconsMap';

const SIZE_MAP = {
  sm: 15,
  md: 20,
  lg: 24,
} as const;

type SizePreset = keyof typeof SIZE_MAP;

export interface SocialIntegrationIconProps {
  type: string | null | undefined;
  size?: SizePreset | number;
  style?: React.CSSProperties;
  className?: string;
}

export const SocialIntegrationIcon = memo(
  ({ type, size = 'md', style, className }: SocialIntegrationIconProps) => {
    if (!type) return null;

    const config = INTEGRATION_ICONS_MAP[type];
    if (!config) return null;

    const pxSize = typeof size === 'number' ? size : SIZE_MAP[size];

    if (config.kind === 'fa') {
      return (
        <FontAwesomeIcon
          icon={config.icon}
          className={className}
          style={{
            fontSize: `${pxSize}px`,
            color: config.color,
            ...(config.fixedWidth && {
              width: `${pxSize}px`,
            }),
            ...style,
          }}
        />
      );
    }

    return (
      <img
        src={config.src}
        alt={config.alt}
        className={className}
        style={{
          width: `${pxSize}px`,
          height: 'auto',
          ...style,
        }}
      />
    );
  }
);
